import React, { useState } from "react";
import { clone } from "lodash";
import OwnersPromptModal from "./OwnersPromptModal";
import { fetchPropertyOwners, buildLessorFromContact } from "./OwnersPromptLogic";
import NotificationAsk from "../../../components/Notification/NotificationAsk";

export const useOwnersPrompt = ({ roleField, roleLabel, data, setData, commitProperty }) => {
    const [ownersPromptOpen, setOwnersPromptOpen] = useState(false);
    const [ownersPromptList, setOwnersPromptList] = useState([]);
    const [pendingChoice, setPendingChoice] = useState(null);
    const [wipeConfirmOpen, setWipeConfirmOpen] = useState(false);

    const runPostCommit = async (chosen, wasInitialOrChanged) => {
        if (!wasInitialOrChanged) return;
        const owners = await fetchPropertyOwners(chosen.id);
        if (owners.length > 0) {
            setOwnersPromptList(owners);
            setOwnersPromptOpen(true);
        }
    };

    const handleChooseProperty = async (chosen, ...args) => {
        const existing = Array.isArray(data[roleField]) ? data[roleField] : [];
        const isPropertyChange = data.property_id && data.property_id !== chosen.id;
        const isInitialPick = !data.property_id;
        if (existing.length > 0 && isPropertyChange) {
            setPendingChoice({ chosen, args });
            setWipeConfirmOpen(true);
            return;
        }
        await commitProperty(chosen, ...args, { wipeRole: isPropertyChange });
        await runPostCommit(chosen, isInitialPick || isPropertyChange);
    };

    const handleConfirmed = (selectedOwners) => {
        if (!selectedOwners || selectedOwners.length === 0) return;
        const newData = clone(data);
        if (!Array.isArray(newData[roleField])) newData[roleField] = [];
        selectedOwners.forEach((o) => {
            newData[roleField].push(buildLessorFromContact(o));
        });
        setData(newData);
    };

    const modals = (
        <>
            {ownersPromptOpen && (
                <OwnersPromptModal
                    open={ownersPromptOpen}
                    close={() => { setOwnersPromptOpen(false); setOwnersPromptList([]); }}
                    owners={ownersPromptList}
                    roleLabel={roleLabel}
                    onConfirm={handleConfirmed}
                />
            )}
            {wipeConfirmOpen && (
                <NotificationAsk
                    open={true}
                    close={() => { setWipeConfirmOpen(false); setPendingChoice(null); }}
                    title="Change Property?"
                    message={`Changing the property will remove the current ${roleLabel}(s). Continue?`}
                    success_button_text="Yes, Change"
                    success={async () => {
                        const p = pendingChoice;
                        setWipeConfirmOpen(false);
                        setPendingChoice(null);
                        if (p) {
                            await commitProperty(p.chosen, ...p.args, { wipeRole: true });
                            await runPostCommit(p.chosen, true);
                        }
                    }}
                />
            )}
        </>
    );

    return { handleChooseProperty, ownersPromptModals: modals };
};
